import { AlertCircle } from "lucide-react";

import { describeError } from "@/api/errors";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ErrorStateProps {
  error: unknown;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({ error, onRetry, className }: ErrorStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 py-12 text-center",
        className,
      )}
    >
      <AlertCircle className="h-12 w-12 text-danger-500" />
      <h3 className="text-lg font-semibold text-ink-950">Algo deu errado</h3>
      <p className="max-w-sm text-sm text-ink-500">{describeError(error)}</p>
      {onRetry ? (
        <Button onClick={onRetry} variant="outline">
          Tentar novamente
        </Button>
      ) : null}
    </div>
  );
}
